import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@mui/material'
import { useSnackbar } from 'notistack'
import { useDeleteSalesPayout } from '../../../api/sales-commission-incentive'
import { getErrorMessage } from '../../../api/utils'

const Delete = ({ openDelete, data, onClose, refetch }) => {
  const { mutateAsync, isLoading } = useDeleteSalesPayout()
  const { enqueueSnackbar } = useSnackbar()

  const handleDeleteAnnouncement = async () => {
    try {
      await mutateAsync({ id: data._id })
      refetch()
      enqueueSnackbar('Successfully removed.', { variant: 'success' })
      onClose()
    } catch (err) {
      enqueueSnackbar(getErrorMessage(err), { variant: 'error' })
    }
  }

  return (
    <Dialog maxWidth='sm' open={openDelete}>
      <DialogTitle>Confirm Deletion</DialogTitle>
      <DialogContent dividers>
        <Typography>
          Are you sure you want to remove sales payout for{' '}
          <b>
            {data.name} ({data.monthYear})
          </b>
          ? This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          variant='contained'
          style={{ background: 'red' }}
          onClick={handleDeleteAnnouncement}
          disabled={isLoading}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default Delete
